import { Empty } from "../@client/Theasoft_ApiServer__Utils_TreeBase"
import { TreePillsInput, TreePillsInputProps } from "./tree/tree-pills-input"
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"
import { t } from "i18next"

interface DepartmentOrWorkareaTreeSelectProps
  extends Omit<TreePillsInputProps<Empty>, "tree"> {
  withModule?: boolean
  withRoot?: boolean
}

export function DepartmentOrWorkareaTreeSelect({
  withModule = true,
  withRoot = true,
  ...props
}: DepartmentOrWorkareaTreeSelectProps) {
  const { data } = useSuspenseQueryGet("/api/WorkArea/GetWorkAreaTree", {
    withModule,
    withRoot,
  })
  return <TreePillsInput label={t("Departments")} {...data} {...props} />
}
